import React from "react";
import VideoForm from "../../../components/admin/videos/VideoForm";

function AddVideo() {
  return (
    <main
      className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B] mt-8 space-y-6"
      style={{ width: "75%" }}
    >
      <h1 className="mb-10 text-center lws-section-title">Add New Video</h1>
      <VideoForm />
    </main>
  );
}

export default AddVideo;
